import PropTypes from 'prop-types'
import { createGlobalStyle } from 'styled-components'
import { normalize } from 'polished'
import '../i18n'

const GlobalStyle = createGlobalStyle`
  ${normalize()}

  *, *::before, *::after {
    box-sizing: inherit;
  }

  html {
    box-sizing: border-box;
    line-height: normal;
  }

  body {
    :lang(en),
    :lang(zh-TW) {
      font-family: 'PingFang TC', 'Microsoft JhengHei', sans-serif;
    }
    :lang(zh-CN) {
      font-family: 'PingFang TC', 'Microsoft YaHei', sans-serif;
    }
  }

  html, body, ul, p, h2 {
    margin: 0;
    padding: 0;
  }

  a {
    text-decoration: none;
    cursor: pointer;
    color: inherit;

    :hover,
    :focus,
    :visited {
      text-decoration: none;
    }
  }

  li {
    list-style-type: none;
  }
`

function Layout({ children }) {
  return (
    <>
      <GlobalStyle />
      {children}
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node,
}

export default Layout
